import { render, staticRenderFns } from "./EarlyCollegeSummit2024.vue?vue&type=template&id=4c981ee8&scoped=true"
import script from "./EarlyCollegeSummit2024.vue?vue&type=script&lang=js"
export * from "./EarlyCollegeSummit2024.vue?vue&type=script&lang=js"
import style0 from "./EarlyCollegeSummit2024.vue?vue&type=style&index=0&id=4c981ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c981ee8",
  null
  
)

export default component.exports